module.exports = __webpack_public_path__ + "img/gamifinnator-yoga.d8b4eae2.png";